<app-dialog-container (onClose)="close()">
    <h3>Select a language</h3>
    <ul role="list" class="divide-y divide-gray-100 min-w-[300px]">
        <li class="flex gap-x-4 py-5 cursor-pointer" *ngFor="let locale of locales | keyvalue">
            <a class="flex gap-4 items-center" href="/{{ locale.value.slug ? locale.value.slug + '/' : ''}}" [class.active]="locale.value.slug === currentLocale">
                <advanced-image
                    class="h-12 w-12 flex-none rounded-sm bg-gray-50"
                    [cldImg]="flags[locale.value.slug || 'en']"
                    [alt]="locale.value.name"
                    [plugins]="plugins"></advanced-image>
                <span class="text-sm font-semibold leading-6 text-gray-900">{{ locale.value.name }}</span>
            </a>
        </li>
    </ul>
</app-dialog-container>
